
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InfraEndPointModel } from '../models/infraendpoint.model';
import { Observable, BehaviorSubject } from 'rxjs';
import JsonData from '../../assets/infraendpoints.json';
import { environment } from 'src/environments/environment';

@Injectable()
export class InfraService {

  private defaultUrl: string = environment.apiUrl;
  private infraEndPoint: InfraEndPointModel = new InfraEndPointModel();
  private infraDetailsSubject: any;
  infraDetails$: Observable<InfraEndPointModel>;
  isInfraDetailsAvailable = false;
  private regionText = new BehaviorSubject<string>('');
  currentRegion = this.regionText.asObservable();

  constructor(private http: HttpClient) {
    this.infraEndPoint.InfraId = 0;
    this.infraEndPoint.TemplateId = 0;
    this.infraEndPoint.CountryId = 0;
    this.infraEndPoint.WebEndPoint1 = '';
    this.infraEndPoint.WebEndPoint2 = '';
    this.infraEndPoint.StorageEndPoint = '';
    this.infraEndPoint.PythonURL = '';
    this.infraEndPoint.RegionName = '';

    this.infraDetailsSubject = new BehaviorSubject<InfraEndPointModel>(this.infraEndPoint);    
    this.infraDetails$ = this.infraDetailsSubject.asObservable();

    const selectedInfra = localStorage.getItem('selectedInfra');
    if (selectedInfra && selectedInfra.split(',').length === 3) {
      this.isInfraDetailsAvailable = true;
      this.setInfraDetails(selectedInfra);
    }
  }

  setInfraDetails(infraDetails: string) {
    // this.http.get(`./assets/infraendpoints-${environment.env}.json`).subscribe((data: InfraEndPointModel[]) => {
    //  let infraArr = infraDetails.split(',');
    //  if (infraArr.length === 3) {
    //    let infraId = parseInt(infraArr[2]);
    //    let newInfraDetails = data.find(x => x.infraId == infraId)
    //    if (newInfraDetails != undefined) {
    //      newInfraDetails.templateId = parseInt(infraArr[1]);
    //      newInfraDetails.countryId = parseInt(infraArr[0])
    //      this.isInfraDetailsAvailable = true;
    //      this.infraDetailsSubject.next(newInfraDetails);
    //    }
    //  }
    // })
    if(infraDetails) {
    const infraArr = infraDetails.split(',');
    if (infraArr.length === 3) {
      const infraId = parseInt(infraArr[2]);
      console.log(infraId,'infraId')
      console.log(JsonData,'jsonData');
      const infraData: InfraEndPointModel[] = JsonData;
      const newInfraDetails = infraData.find(x => x.InfraId == infraId);
      console.log(newInfraDetails,'newInfraDetails');
      if (newInfraDetails != undefined) {
        newInfraDetails.TemplateId = parseInt(infraArr[1]);
        newInfraDetails.CountryId = parseInt(infraArr[0]);
          this.isInfraDetailsAvailable = true;
          this.infraDetailsSubject.next(newInfraDetails);
        }
    }
  }
  }

  setRegion(region) {
      this.regionText.next(region);
  }  
}
